import GamesConfig from "./GamesConfig"
import Constant from "../Shared/Constant";
import GameList from "../Models/GameList";
import { Global } from "../Shared/Global";

const {ccclass, property} = cc._decorator;

@ccclass
export default class LiveVideoLayer extends cc.Component {
    @property(cc.Node)
    nodeContent: cc.Node = null

    @property(cc.Sprite)
    spGirl: cc.Sprite = null
    
    @property(cc.Widget)
    wgtTable: cc.Widget = null

    private _girlSpriteFrames: {} = {}
    private _curNodeToggle: cc.Node = null

    onLoad () {
        this.nodeContent.removeAllChildren()

        if (cc.winSize.width / cc.winSize.height > 2) {
            this.wgtTable.left += Constant.BangLength
        }

        cc.director.on(Global.UserEvent.GameListChanged, this.createNodeItems, this)
    }

    onEnable () {
        if (GameList.serverData) {
            if (!this._curNodeToggle) {
                this.selectNodeToggle(this.nodeContent.children[0])
            }

            this.nodeContent.y = 0
            this.showItems()
        }
    }

    onDestroy () {
        cc.director.off(Global.UserEvent.GameListChanged, this.createNodeItems, this)
    }

    onBtnClick (event, userData) {
        if (userData === "touzhu") {
            cc.find("Canvas/gameNode").getComponent("HallUI").enterGame(this._curNodeToggle["gameConfig"])
        }else if (userData === "toggle") {
            this.selectNodeToggle(event.target)
        }
    }

    private createNodeItems () {
        if (!GameList.serverData) {
            return
        }
        
        let topGamesCfg = GameList.getGameListByType(Global.GameType.Live)
        let items = topGamesCfg["twoLevelList"] || [] 
        
        items.forEach(item => {
            let node = new cc.Node()
            let nodeBg = new cc.Node()
            let nodeMark = new cc.Node()
            let bgSprite = nodeBg.addComponent(cc.Sprite)
            let markSprite = nodeMark.addComponent(cc.Sprite)
            let button = node.addComponent(cc.Button);
            let res = GamesConfig.livevideo[item.gameTitleCn]

            nodeBg.parent = node
            nodeBg.name = "bg"
            nodeMark.parent = node
            nodeMark.active = false
            nodeMark.name = "mark"
            node.name = "toggle" + this.nodeContent.children.length
            node.parent = this.nodeContent
            node.setContentSize(367, 128)

            if (!res) {
                res = "Hall/LiveVideo/ag"
                
                if (Constant.RemindMissingRes) {
                    let nodeLabel = new cc.Node()
                    let lbLack = nodeLabel.addComponent(cc.Label)
                    
                    nodeLabel.color = cc.color(255, 0, 0)
                    nodeLabel.parent = node
                    lbLack.string = item.gameTitleCn + "\n缺少美术资源！"
                    lbLack.fontSize = 40
                }
            }

            cc.loader.loadRes(res + "_1", cc.SpriteFrame, function (err, spriteFrame) {
                if (!err && this.node) {
                    this._girlSpriteFrames[node.name] = spriteFrame

                    if (this._curNodeToggle && this._curNodeToggle === node) {
                        this.spGirl.spriteFrame = spriteFrame
                    }
                }
            }.bind(this))

            cc.loader.loadRes(res + "_2", cc.SpriteFrame, function (err, spriteFrame) {
                if (!err && this.node) {
                    bgSprite.spriteFrame = spriteFrame
                }
            }.bind(this))

            cc.loader.loadRes(res + "_3", cc.SpriteFrame, function (err, spriteFrame) {
                if (!err && this.node) {
                    markSprite.spriteFrame = spriteFrame
                }
            }.bind(this))    

            // 游戏维护
            if (item.gameStatus === "2") {
                let nodeMaintenance = new cc.Node()
                let spMaintenance = nodeMaintenance.addComponent(cc.Sprite)
                
                nodeMaintenance.parent = node
                nodeBg.color = cc.color(70, 70, 70)
                nodeMark.color = cc.color(70, 70, 70)

                cc.loader.loadRes("Common/maintenance", cc.SpriteFrame, function (err, spriteFrame) {
                    if (!err && spMaintenance && spMaintenance.isValid) {
                        spMaintenance.spriteFrame = spriteFrame
                    }
                }.bind(this))
            }
            
            let clickEventHandler = new cc.Component.EventHandler()
            clickEventHandler.target = this.node
            clickEventHandler.component = "LiveVideoLayer"
            clickEventHandler.handler = "onBtnClick"
            clickEventHandler.customEventData = "toggle"
            button.clickEvents.push(clickEventHandler)
            button.node["gameConfig"] = item
        });
    }

    private showItems () {
        for (let i = 0; i < this.nodeContent.children.length; i++) {
            const node = this.nodeContent.children[i];
            node.x = node.width
            node.runAction(cc.sequence(cc.delayTime(i * 0.07), cc.moveTo(0.2, 0, node.y).easing(cc.easeSineOut())))
        }
    }

    selectNodeToggle (node) {
        if (this._curNodeToggle === node) {
            return
        }

        if (this._curNodeToggle) {
            this._curNodeToggle.getChildByName("mark").active = false
            this._curNodeToggle.getChildByName("bg").active = true
        }

        this._curNodeToggle = node
        this._curNodeToggle.getChildByName("mark").active = true
        this._curNodeToggle.getChildByName("bg").active = false

        let spriteFrame = this._girlSpriteFrames[node.name]

        if (spriteFrame) {
            this.spGirl.spriteFrame = spriteFrame
        }
    }
}
